export interface DayUnitPrice {
  price: number;
  source: "level" | "asp";
}

// Resolves the unit price to use for a day's revenue line: the product's
// price for that day's price level when one applies, else the row's target
// ASP, else null (no price available). Zero/absent prices count as missing
// so a $0 level price falls back to ASP rather than zeroing the revenue.
export function dayUnitPrice(
  pricesByLevel: Record<string, number> | undefined,
  asp: number | undefined,
  levelId: string | undefined,
): DayUnitPrice | null {
  if (levelId) {
    const levelPrice = pricesByLevel?.[levelId];
    if (levelPrice && levelPrice > 0) {
      return { price: levelPrice, source: "level" };
    }
  }
  if (asp && asp > 0) {
    return { price: asp, source: "asp" };
  }
  return null;
}
